/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 */

export function convertColor(color: string): string {
  return 'transparent' === color ? color : `#${color}`;
}
